<template>
	<div class="sy-ch-main text-center container400">
		<!-- EDIT -->
		<table align="center" style="font-size:18px;text-align:left;margin:auto;" class="normal" v-on:keyup.enter = "editSubmit" v-if = "editing" >
			<tbody>
				<tr>
					<td class="pb1">
						<div class="mb1">
							<button  @click = "cancel" class="btn mr7">Cancel</button>
							<button  @click = "editSubmit" class="btn">Update</button>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="Email">Email</label>
							<input readonly type = "email" placeholder = "example@email.com" v-model.trim = " editForm['Email']">
							<p class = "font-red">{{ errorMsg['Email']}}</p>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="Old-Password">Old Password</label>
							<input id = "Old-Password" type = "password" class="password" placeholder = "******" v-model.trim = " editForm['Old Password']">
							<div class="show-password text-right">Show</div>
							<p class = "font-red">{{ errorMsg['Old Password']}}</p>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="New-Password">New Password</label>
							<input id = "New-Password" type = "password" class="password" placeholder = "******" v-model.trim = " editForm['New Password']">
							<div class="show-password text-right">Show</div>
							<p class = "font-red">{{ errorMsg['New Password']}}</p>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- VIEW -->
		<table align="center" style="text-align:left;margin:auto;" class="container400" v-else>
			<tbody>
				<tr>
					<td>
						<div class="form_control mb2">
							<label for="input-email">Current Email</label>
							{{email}}
						</div>
						<div class="form_control mb2">
							<button  @click = "editStart(oriItem)" class="btn">Update Password</button>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control mb2">
							<a class="btn" @click = "logout">
								Logout
							</a>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <h2>Commissions</h2>
		<table align="center" style="text-align:left;margin:auto;" class="container400">
			<thead>
				<tr>
					<th>Commission Name</th>
					<th>Amount</th>
					<th>Of</th>
					<th>Date</th>
					<th>End Date</th>
				</tr>
			</thead>
			<tbody v-for = "ct in CommissionTargetChoices">
				<tr v-for = "item in commissions.filter(r=>{return r['Commission Target'] == ct;})">
					<td>
						{{item['Commission Name']}}
						<br>
						({{ct}})
					</td>
					<td>
						<span v-if = "item['Structure']['Calculation Type'] === 'Flat Rate'">
							{{formatPrice(item['Structure']['Flat Rate'])}}
						</span>
						<span v-else-if = "item['Structure']['Calculation Type'] === 'Percentage'">
							{{item['Structure']['Percentage']}}
						</span>
						<span v-else>
							Whichever {{item['Structure']['Calculation Type']}}
							<br>
							{{formatPrice(item['Structure']['Flat Rate'])}} or {{item['Structure']['Percentage']}}%
						</span>
					</td>
					<td>
						<span v-if = "['Percentage', 'Higher', 'Lower'].includes(item['Structure']['Calculation Type'])">
							{{item['Structure']['Percentage Field']}}
						</span>
						<span v-else>
							Per Order
						</span>
					</td>
					<td>
						{{formatDate(item['Start Date'])}}
					</td>
					<td>
						{{formatDate(item['End Date'])}}
					</td>
				</tr>
			</tbody>
		</table> -->
		<div class="language mt4 text-left">
			<div class="fz-15">
				<span>Language: {{language}}</span>
				<br>
				<i @click = "changeLanguage"><u>Edit Language</u></i>
			</div>
		</div>
	</div>
</template>

<script>
var md5 = require('md5');
var uuid = require('uuid/v5');
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Email","checkFun":"email","children":[],"defaultValue":"","inputType":"email","manyView":true,"max":"","min":"","placeholder":"example@email.com","singleView":true,"type":"Email"},{"Name":"Old Password","checkFun":"text","children":[],"defaultValue":"","inputType":"password","manyView":true,"max":"","min":"","placeholder":"Old Password","singleView":true,"type":"Password"},{"Name":"New Password","checkFun":"WeakPW","children":[],"defaultValue":"","inputType":"password","manyView":true,"max":"","min":"","placeholder":"New Password","singleView":true,"type":"Password"}];
		return{
			// FORM
			editForm: {},
			errorMsg: {},

			// NAV VARIABLES
			editing: false,
			email: myFB.auth.currentUser.email,
			commissions: [],
			CommissionTargetChoices: ["Merchant","Customer"],
			language: this.$store.getters.getLanguage()
		}
	},
	//==============================================//
	//												//
	//					MOUNTED						//
	//												//
	//==============================================//
	mounted(){
	},
	firestore(){
		this.$binding("commissions", myFB.getCol("commissionsPublic").where("BusinessIDs", "array-contains", this.$route.params.businessID)).then(r=>{

		})
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "y-m-d",
			}
			return myDate.displayDate(input, mode);
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(){
			var editForm ={
				Email: myFB.auth.currentUser.email,
				"Old Password": "",
				"New Password": "",
			};
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.errorMsg = response.errorMsg;
			this.editForm = response.output;
			this.editing = true;
			setTimeout(function(){
				$('.show-password').click(function(){
					$('.show-password').toggleClass('active');
					if($('.show-password').hasClass('active')){
						// $('input.password').attr('type','password');
						$('input.password').attr('type','text');
						$('.show-password').html('Hide');
					}else{
						$('input.password').attr('type','password');
						$('.show-password').html('Show');
					}
				});
			},500)
		},
		editSubmit(){
			var item, response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				myNotify.loading();
				myFB.auth.signInWithEmailAndPassword(editForm["Email"], editForm["Old Password"]).then(user=>{
					myFB.auth.currentUser.updatePassword(editForm["New Password"]).then(r=>{
						myNotify.loadStop();
						myNotify.toast("Password updated!", 3000);
						this.cancel();

					}).catch(e=>{
						myNotify.loadStop();
						console.log(e.message);
						this.errorMsg["New Password"] = e.message;
					})
				}).catch(e=>{
					myNotify.loadStop();
					console.log(e.message);
					this.errorMsg["Old Password"] = "Wrong password";
				})
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.editing = false;
		},
		logout(){
			myFB.auth.signOut().then(r=>{
				var prefix = "/" +  this.$route.params.businessID;
				this.$router.push(prefix + "/login");
			}).catch(e=>{
				console.log(e.message);
			})
		},
		changeLanguage(){
			language.show();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/UpdatePassword.vue